<script setup lang="ts">
import { useData } from "vitepress";
import { computed } from "vue";
import { data as articles } from "../../../../articles/index.data.js";
import PageLinkCard from "../content/PageLinkCard.vue";

const { page } = useData();

// relativePath here is always "projects/<slug>/index.md".
const projectPrefix = computed(() => {
  const match = page.value.relativePath.match(/^projects\/([^/]+)\//);
  return match ? `/projects/${match[1]}/` : null;
});

const projectArticles = computed(() => {
  const prefix = projectPrefix.value;
  if (!prefix) return [];
  return articles.filter((article) => article.url.startsWith(prefix));
});
</script>

<template>
  <!-- Nothing to say is better said by saying nothing: a project with no
       articles yet drops the section entirely rather than showing an empty
       heading. -->
  <section v-if="projectArticles.length" class="project-articles">
    <h2 class="project-articles-title">Writing</h2>

    <div class="project-articles-grid">
      <PageLinkCard
        v-for="article in projectArticles"
        :key="article.url"
        :item="article"
        link-text="Read article"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
@use "../../styles/abstracts/breakpoints" as *;

.project-articles {
  margin-top: var(--space-3xl);
}

.project-articles-title {
  margin-bottom: var(--space-lg);
  padding-bottom: var(--space-sm);
  border-bottom: 1px solid var(--color-border);
}

.project-articles-grid {
  display: grid;
  gap: 2rem;

  @include lg {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }
}

</style>
